<header>
    
    <div class="show-logo" [responsiveBackgroundImage]="show ? (show.web_banner_landing_page || show.logo1_landscape) : null"></div>
    <nav>
        <ul *ngIf="!show" class="nav">
            <li><a>Loading...</a></li>
        </ul>
        
        <ng-container *ngIf="show">
            <ul class="nav" *ngIf="!enableTabCollapse">
                <li class="live-tab" *ngIf="activeLiveStream"><a routerLink="/live/streams/{{activeLiveStream.id}}">
                    <span>Live</span>
                </a></li>
                <li *ngIf="show.enable_vod" [class.active]="section == 'episodes'"><a routerLink="/shows/{{show.slug || show.id}}/episodes">
                    Episodes
                    <img src="assets/subnav_pointer.svg" class="sub-nav-pointer" />
                </a></li>
                <li *ngIf="show.enable_clips" [class.active]="section == 'clips'"><a routerLink="/shows/{{show.slug || show.id}}/clips">
                    Clips
                    <img src="assets/subnav_pointer.svg" class="sub-nav-pointer" />
                </a></li>
                <li *ngIf="show.enable_podcasting" [class.active]="section == 'podcasts'"><a routerLink="/shows/{{show.slug || show.id}}/podcasts">
                    Podcasts
                    <img src="assets/subnav_pointer.svg" class="sub-nav-pointer" />
                </a></li>
                <li *ngIf="show.enable_text_articles" [class.active]="section == 'articles'"><a routerLink="/shows/{{show.slug || show.id}}/articles">
                    Articles
                    <img src="assets/subnav_pointer.svg" class="sub-nav-pointer" />
                </a></li>
                <li [class.active]="section == 'about'"><a routerLink="/shows/{{show.slug || show.id}}/about">
                    About
                    <img src="assets/subnav_pointer.svg" class="sub-nav-pointer" />
                </a></li>
            </ul>

            <ul class="nav" *ngIf="enableTabCollapse">
                <li class="live-tab" *ngIf="activeLiveStream"><a routerLink="/live/streams/{{activeLiveStream.id}}">
                    <span>Live</span>
                </a></li>
                <ng-container *ngFor="let tab of visibleTabs">
                    <ng-container *ngIf="tab.id != 'live'">
                        <li [class.active]="section == tab.id"><a routerLink="{{tab.url}}">
                            {{tab.label}}
                            <img src="assets/subnav_pointer.svg" class="sub-nav-pointer" />
                        </a></li>
                    </ng-container>
                </ng-container>
                <li class="more-container" *ngIf="overflowTabs.length">
                    <a href="javascript:;" (click)="moreTabOpen = !moreTabOpen">More
                        <i *ngIf="!moreTabOpen" class="fas fa-caret-down"></i>
                        <i *ngIf="moreTabOpen" class="fas fa-caret-up"></i>
                    </a>
                    <div class="more {{ moreTabOpen ? 'block': ''}}">
                        <ng-container *ngFor="let tab of overflowTabs">
                            <li [class.active]="section == tab.id"><a routerLink="{{tab.url}}">{{tab.label}}</a></li>
                        </ng-container>
                    </div>
                </li>
            </ul>
        </ng-container>
    </nav>
</header>